var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "position-relative" }, [
    _c("div", { staticClass: "d-flex justify-content-between" }, [
      _c("div", [
        _c(
          "span",
          {
            staticClass: "section-separator-title",
            class: { invisible: _vm.invisibleTile },
            attrs: { id: "h2" },
          },
          [_vm._t("title")],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex flex-row flex-no-wrap align-items-center" },
          [
            _c(
              "span",
              {
                staticClass:
                  "section-separator-title text-primary text-truncate mr-1",
                attrs: { id: "h3" },
              },
              [_vm._t("sub-title")],
              2
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "section-separator-title", attrs: { id: "h4" } },
              [_vm._t("extra")],
              2
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c("div", [_vm._t("title-right")], 2),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }